import type { CurrentRefinementsProvided } from 'react-instantsearch-core';

/* @deprecated */
export const getAppliedFilters = (items: CurrentRefinementsProvided['items'][0][]) => {
  const filtersApplied: Record<string, string[] | string> = {};

  if (!items || !items.length) {
    return filtersApplied;
  }

  items.forEach((filterCategory) => {
    filtersApplied[filterCategory.attribute] = filterCategory.currentRefinement;
  });

  return filtersApplied;
};
